import { Injectable, Injector, OnInit } from '@angular/core';
import { differenceBy, startsWith, has, get, defaultsDeep, isEmpty, assign } from 'lodash';

import { BehaviorSubject } from 'rxjs';
const optionsKey = 'back:options';

@Injectable()
export class Layoutresolver implements OnInit {
	url: string;
	staticContentModel: StaticContentModel;
	auditInfo: auditInfo;
	controls: controls;
	answers: answers;
	errors: errors;
	metadata: metadata;
	globalAttributes: {};
	dynamicContent: {};
	ui: ui;
	instructions: any;
	constructor() {}

	async ngOnInit() {}

	resolve(response: Response, staticLayout: BehaviorSubject<StaticContentModel>) {
		if (has(response, 'data.metadata')) {
			if (response.data.metadata.page.state === 'preloader') {
			}
		}

		if (startsWith(response.action, 'render')) {
			if (
				staticLayout &&
				staticLayout.getValue() &&
				staticLayout.getValue().data &&
				staticLayout.getValue().data.answers
			) {
				console.log(
					'resolve-setTimeout-staticLayout.getValue().data.answers.page',
					staticLayout.getValue().data.answers.page
				);
			}

			const renderType = response.action.split(':')[1];

			response.action = renderType;
			this.instructions = {
				data: renderType == 'page' ? get(response, 'instructions.data') : get(response.data, 'instructions.data'),
				error: renderType == 'page' ? get(response, 'instructions.errors') : get(response.data, 'instructions.errors'),
			};
			this.staticContentModel = {
				action: renderType,
				splunkTimerId: null,
				data: {
					addonParams: response.data.addonParams,
					auditInfo:
						renderType == 'page'
							? this.updateAuditing(response, renderType, get(response, 'instructions.audit'))
							: staticLayout.getValue().data.auditInfo,
					controls: this.updateControls(response, renderType, staticLayout),
					dynamicContent: this.updatedynamicContent(response, renderType, staticLayout),
					answers: this.updateAnswers(response, renderType, this.instructions.data, staticLayout),
					errors: this.updateErrors(response, renderType, this.instructions.error),
					globalAttributes: this.updateglobalAttributes(response, renderType, staticLayout),
					metadata: this.updateMetaData(response, renderType, staticLayout),
					instructions: this.updateInstructions(response, renderType, staticLayout),
					ui: this.updateUi(response, renderType, staticLayout),
				},
			};

			if (response.data && response.data.globalAttributes && response.data.globalAttributes.abTests) {
				(<any>window).allTests = response.data.globalAttributes.abTests;
			}

			if (response.data.globalAttributes && response.data.globalAttributes.backOptions) {
				sessionStorage.setItem(optionsKey, response.data.globalAttributes.backOptions);
			}
		}
		window['store'] = this.staticContentModel;
		return this.staticContentModel;
	}

	updateMetaData(response: Response, renderType: string, staticLayout: BehaviorSubject<StaticContentModel>) {
		switch (renderType) {
			case 'page':
				if (response.instructions && response.instructions['metadata.header.floater'] == 'merge') {
					if (this.staticContentModel && this.staticContentModel.data) {
						const mergeFolater = defaultsDeep(
							{},
							this.staticContentModel.data.metadata.header.floater,
							response.data.metadata.header.floater
						);
						response.data.metadata.header.floater = mergeFolater;
					}
				}
				if (response.instructions && response.instructions['metadata.header.popups'] == 'merge') {
					if (this.staticContentModel && this.staticContentModel.data) {
						const mergePopups = defaultsDeep(
							{},
							this.staticContentModel.data.metadata.header.popups,
							response.data.metadata.header.popups
						);
						response.data.metadata.header.popups = mergePopups;
					}
				}
				return response.data.metadata;

			case 'popup':
			case 'modal':
				return staticLayout.getValue().data.metadata;
		}
	}

	updateInstructions(response: Response, renderType: string, staticLayout: BehaviorSubject<StaticContentModel>) {
		switch (renderType) {
			case 'page':
				return response.data.instructions;
			case 'popup':
			case 'modal':
				return staticLayout.getValue().data.instructions;
		}
	}

	updateAnswers(
		response: Response,
		renderType: string,
		instructions: string,
		staticLayout: BehaviorSubject<StaticContentModel>
	) {
		this.answers = {
			page: {},
			modal: {},
			popup: {},
		};
		switch (renderType) {
			case 'page':
				if (instructions === 'override') {
					this.answers[renderType] = response.data.data;
					return this.answers;
				}
				if (instructions === 'merge') {
					if (this.staticContentModel && this.staticContentModel.data) {
						const mergedObject = assign({}, response.data.data, staticLayout.getValue().data.answers.page);
						this.answers[renderType] = mergedObject;
					} else {
						this.answers[renderType] = response.data.data;
					}
					return this.answers;
				}
				this.answers[renderType] = response.data.data;
				return this.answers;

			case 'popup':
			case 'modal':
				this.staticContentModel.data.answers[renderType] = response.data.data;
				return this.staticContentModel.data.answers;
		}
	}

	updateErrors(response: Response, renderType: string, instructions: string) {
		this.errors = {
			modal: {},
			page: {},
			popup: {},
		};
		if (instructions === 'override') {
			this.errors[renderType] = response.data.errors ? response.data.errors : {};
			return this.errors;
		}
		if (instructions === 'merge') {
			if (this.staticContentModel && this.staticContentModel.data) {
				const mergedObject = defaultsDeep({}, this.staticContentModel.data.errors[renderType], response.data.errors);
				this.errors[renderType] = mergedObject;
			} else {
				this.errors[renderType] = response.data.errors ? response.data.errors : {};
			}
			return this.errors;
		}
		this.errors[renderType] = !isEmpty(response.data.errors) ? response.data.errors : {};
		return this.errors;
	}

	updateAuditing(response: Response, renderType: string, instructions: string) {
		this.auditInfo = {
			page: {},
			modal: {},
			popup: {},
		};
		if (instructions === 'override') {
			return (this.auditInfo[renderType] = response.data.auditInfo);
		}
		if (instructions === 'merge') {
			if (this.staticContentModel && this.staticContentModel.data) {
				const mergedObject = defaultsDeep(
					{},
					response.data.auditInfo,
					this.staticContentModel.data.auditInfo[renderType]
				);
				this.auditInfo[renderType] = mergedObject;
			} else {
				return (this.auditInfo[renderType] = response.data.auditInfo);
			}
			return this.auditInfo;
		}

		if (!isEmpty(response.data.auditInfo)) {
			this.auditInfo[renderType] = response.data.auditInfo;
		}

		return this.auditInfo;
	}

	updateControls(response: Response, renderType: string, staticLayout: BehaviorSubject<StaticContentModel>) {
		this.controls = {
			modal: {},
			page: {},
			popup: {},
		};

		switch (renderType) {
			case 'page':
				let pageControls = response.data.metadata.page.controls;
				this.controls[renderType] = pageControls;
				break;

			case 'popup':
			case 'modal':
				let popupControls = response.data.controls;
				this.controls[renderType] = popupControls;
				this.controls['page'] = staticLayout.getValue().data.ui.page.controls;
				break;
		}

		return this.controls;
	}

	updateUi(response: Response, renderType: string, staticLayout: BehaviorSubject<StaticContentModel>) {
		this.ui = {
			modal: {},
			page: {},
			popup: {},
		};
		switch (renderType) {
			case 'page':
				this.ui.page = response.data.metadata.page;
				break;
			case 'popup':
			case 'modal':
				this.ui[renderType] = response.data;
				this.ui.page = staticLayout.getValue().data.ui.page;
				break;
		}
		return this.ui;
	}

	updateglobalAttributes(response: Response, renderType: string, staticLayout: BehaviorSubject<StaticContentModel>) {
		this.globalAttributes = {};
		switch (renderType) {
			case 'page':
				this.globalAttributes = response.data.globalAttributes;
				break;
			case 'popup':
			case 'modal':
				this.globalAttributes = staticLayout.getValue().data.globalAttributes;
				break;
		}
		return this.globalAttributes;
	}

	updatedynamicContent(response: Response, renderType: string, staticLayout: BehaviorSubject<StaticContentModel>) {
		this.dynamicContent = {};
		switch (renderType) {
			case 'page':
				this.dynamicContent = response.data.dynamicContent;
				break;
			case 'popup':
			case 'modal':
				this.dynamicContent = staticLayout.getValue().data.dynamicContent;
				break;
		}
		return this.dynamicContent;
	}
}
